import { ActionReducerMap } from '@ngrx/store';
import * as reducers from './reducers';

export interface AppState {
  ui: reducers.UIState;
  topBar: reducers.TopBarState;
  requestpermissionList: reducers.RequestPermissionListState;
  profile: reducers.ProfileState;
  shared: reducers.SharedState;
}

export const appReducers: ActionReducerMap<AppState> = {
  ui: reducers.uiReducer,
  topBar: reducers.topbarReducer,
  requestpermissionList: reducers.requestPermissionListInitialStateListReducer,
  profile: reducers.profileReducer,
  shared: reducers.sharedReducer,
};
